<template>
  <div>
    <div v-if="display == 'ssh241'">
      <span class="wordsOne">1</span>
      <span class="wordsFour">4</span>
      <span class="wordsTwo">2</span>

      <div class="f-betlot-top">
        <div class="fantan-bet-lot-cell">
          <div
            class="fantan-bet-lot-title"
            :class="{ [size]: size }"
            justify="center"
            align="middle"
          >
            <!-- <span v-html="display"></span> -->
            <!-- <span v-html="(`${type}`)"></span> -->

            <span>{{ $t("fantan.ssh") }}</span>
            <span class="typecolor2">{{ this.type.charAt(3) }}</span>
            <span class="typecolor4">{{ this.type.charAt(4) }}</span>
            <span class="typecolor1">{{ this.type.charAt(5) }}</span>
          </div>
        </div>
        <div
          class="fantan-bet-lot-bet-no"
          :class="{ [size]: size }"
          justify="center"
        >
          {{ odd }}
        </div>
      </div>
    </div>
    <div v-if="display == 'ssh234'" style="padding: 61px 0 0">
      <span class="wordsTwo" style="margin: 4px 8px">2</span>
      <br />
      <span class="wordsThree" style="margin: 4px 8px">3</span>
      <br />
      <span class="wordsFour" style="margin: 4px 8px">4</span>

      <div class="f-betlot-side">
        <div class="fantan-bet-lot-cell">
          <div
            class="fantan-bet-lot-title"
            :class="{ [size]: size }"
            justify="center"
            align="middle"
          >
            <span>{{ $t("fantan.ssh") }}</span>
            <span class="typecolor2">{{ this.type.charAt(3) }}</span>
            <span class="typecolor3">{{ this.type.charAt(4) }}</span>
            <span class="typecolor4">{{ this.type.charAt(5) }}</span>
          </div>
        </div>
        <div
          class="fantan-bet-lot-bet-no"
          :class="{ [size]: size }"
          justify="center"
        >
          {{ odd }}
        </div>
      </div>
    </div>

    <div v-if="display == 'ssh123'">
      <span class="wordsOne">1</span>
      <span class="wordsTwo">2</span>
      <span class="wordsThree">3</span>

      <div class="f-betlot-bottom">
        <div class="fantan-bet-lot-cell">
          <div
            class="fantan-bet-lot-title"
            :class="{ [size]: size }"
            justify="center"
            align="middle"
          >
            <span>{{ $t("fantan.ssh") }}</span>
            <span class="typecolor1">{{ this.type.charAt(3) }}</span>
            <span class="typecolor2">{{ this.type.charAt(4) }}</span>
            <span class="typecolor3">{{ this.type.charAt(5) }}</span>
          </div>
        </div>
        <div
          class="fantan-bet-lot-bet-no"
          :class="{ [size]: size }"
          justify="center"
        >
          {{ odd }}
        </div>
      </div>
    </div>
    <div v-if="display == 'ssh341'" style="padding: 61px 0 0">
      <span class="wordsThree" style="margin: 4px 8px">3</span>
      <br />
      <span class="wordsFour" style="margin: 4px 8px">4</span>
      <br />
      <span class="wordsOne" style="margin: 4px 8px">1</span>

      <div class="f-betlot-side">
        <div class="fantan-bet-lot-cell">
          <div
            class="fantan-bet-lot-title"
            :class="{ [size]: size }"
            justify="center"
            align="middle"
          >
            <span>{{ $t("fantan.ssh") }}</span>
            <span class="typecolor3">{{ this.type.charAt(3) }}</span>
            <span class="typecolor4">{{ this.type.charAt(4) }}</span>
            <span class="typecolor1">{{ this.type.charAt(5) }}</span>
          </div>
        </div>
        <div
          class="fantan-bet-lot-bet-no"
          :class="{ [size]: size }"
          justify="center"
        >
          {{ odd }}
        </div>
      </div>
    </div>

    <div v-if="stakeRecordSum" class="fantan-bet-lot-stake-total">
      {{ stakeRecord }}
    </div>
  </div>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: [
    "type",
    "odd",
    "win",
    "game",
    "size",
    "stakeRecordSum",
    "align",
    "display",
  ],
  components: {
    Row,
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    },
  },
};
</script>

<style lang="scss" scoped>
.typecolor1 {
  color: #c9c9c9;
}

.typecolor2 {
  color: #16cc86;
}

.typecolor3 {
  color: #f9cb62;
}

.typecolor4 {
  color: #fa4358;
}

.divider {
  height: 10px;
  display: block;
  clear: both;
}

.square {
  width: 25%;
  float: left;
  background-color: black;
  position: relative;
}

svg {
  height: 100%;
  width: 100%;
}

polygon {
  stroke-linejoin: round;
  stroke: black;
  stroke-width: 5px;
  stroke-linejoin: round;
}

.top {
  fill: yellow;
}

.left {
  fill: red;
}

.bottom {
  fill: white;
}

.right {
  fill: green;
}

.wordsOne {
  color: #c9c9c9;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.wordsTwo {
  color: #16cc86;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.wordsThree {
  color: #f9cb62;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.wordsFour {
  color: #fa4358;
  font-size: 15px;
  font-weight: bold;
  width: 35px;
  height: 35px;
  border: solid;
  border-radius: 50%;
  display: inline-block;
  margin: 8px 4px;
  text-align: center;
  line-height: 30px;
}

.f-betlot-top {
  position: absolute;
  top: 0;
  right: 0;
  padding: 8px 15px 0 0;
}

.f-betlot-side {
  width: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  padding: 9px 0 0;
}

.f-betlot-bottom {
  position: absolute;
  top: 0;
  left: 0;
  padding: 8px 15px 0;
}

.fantan-bet-lot-cell {
  width: 100%;
  text-align: center;
  position: relative;
}

.fantan-bet-lot-cell.small {
  padding-top: 10px;
  padding-bottom: 6px;
}

.fantan-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.fantan-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.fantan-bet-lot-title-left {
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}

.fantan-bet-lot-title-right {
  text-align: right;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}

.fantan-bet-lot-title.small {
  height: unset;
  margin-top: 5px;
}

.fantan-bet-lot-title {
  font-family: "Oswald";
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  // text-transform: uppercase;
}

.fantan-bet-lot-bet-no {
  // @extend .tai-xiu-game-bet-no;
  margin-top: 0px;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  font-family: "Oswald";
}

.fantan-bet-lot-bet-no.small {
  height: unset;
}
</style>

<style lang="scss">
.fantan-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}
</style>
